import { clsx } from '@mantine/styles'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import classes from './RequestNonprofitPrompt.module.scss'
import { ButtonText, Text } from '@percent/lemonade'
import { AppRoute } from '@percent/workplace-giving/routing/AppRoute.enum'
import { useAnalytics } from '@percent/workplace-giving/common/hooks/useAnalytics/useAnalytics'
import { useAuth } from '@percent/workplace-giving/common/hooks'
import { getAccountFromAuthState } from '@percent/workplace-giving/context/auth/authContextController/AuthContextController'

type RequestNonprofitPromptProps = {
  eventOrigin: string
  align?: 'start' | 'center'
}

export function RequestNonprofitPrompt({ eventOrigin, align = 'center' }: RequestNonprofitPromptProps) {
  const { t } = useTranslation()
  const { track } = useAnalytics()
  const { state } = useAuth()
  const account = getAccountFromAuthState(state)

  const navigate = useNavigate()

  const handleRequestNonprofit = () => {
    navigate(AppRoute.REQUEST_NONPROFIT)
    track({
      event: 'Request Nonprofit Validation Form Opened',
      properties: {
        userId: account?.id,
        origin: eventOrigin
      }
    })
  }

  return (
    <div className={clsx(classes.RequestNonprofitWrapper, align === 'start' && classes.RequestNonprofitWrapperStart)}>
      <Text size="small">{t('workplace_giving.common.cantFindANonprofit')}</Text>
      <ButtonText variant="primary" onClick={handleRequestNonprofit} data-testid="btn-request-nonprofit">
        {t('workplace_giving.common.submitARequest')}
      </ButtonText>
    </div>
  )
}
